/* global JQuery */

import {Modal} from 'bootstrap';
import StoreLocator from '../../../components/StoreLocator';
import Helper from '../../../../../../common/utils/helper';
import SlotTime from '../../../components/SlotTime';
import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr.js"

export default class Cart {
    CnCModal: HTMLElement | null;

    addressModal: HTMLElement | null;

    CnCModalInstance: Modal | null;

    addressModalInstance: Modal | null;

    currentShopId: number | null;

    constructor() {
        this.init();
    }

    init() {
        this.initEvents();
        this.initSelectShippingMeans();
        this.initCnCModal();
    }

    getSelectorInputQuantity() {
        return "input[name='product-count']";
    }

    getSelectorRemoveCartLine() {
        return 'a.order-item-card-remove';
    }

    getSelectorCartLine() {
        return '.order-item-card';
    }

    getSelectorChangeShippingMeans() {
        return "input[name='shipping_means']";
    }

    getSelectorChooseAddress() {
        return 'a.choose-address';
    }

    getSelectorAddAddress() {
        return 'a.add-address';
    }

    getSelectorEditAddress() {
        return 'a.edit-address';
    }

    getSelectorResetCart() {
        return 'a#reset_cart';
    }

    getElementAddCodePromo() {
        return $(this.getSelectorValueCodePromo());
    }

    getSelectorRemoveCodePromo() {
        return '#remove-cart-svg';
    }

    getSelectorRemoveDeliveryDate() {
        return '#remove-delivery-date';
    }

    getSelectorComment() {
        return '#comment';
    }

    getSelectorConstructionName() {
        return '#construction-name';
    }

    getSelectorDeliveryWishElement() {
        return '#calendar-select-range';
    }

    getElementRemoveCodePromo() {
        return $(this.getSelectorRemoveCodePromo());
    }

    getElementRemoveDeliveryDate() {
        return $(this.getSelectorRemoveDeliveryDate());
    }

    getSelectorValueCodePromo() {
        return 'input[name="promocode"]';
    }

    getSelectorApplyCodePromo() {
        return '.promo-code-input button';
    }

    getAllCartTemplate() {
        return [
            'cart-header',
            'cart-date',
            'cart-shopping',
            'cart-sidebar',
            'cart-addresses',
            'cart-payment-means',
            'cart-command-type',
        ];
    }

    getSideBarCartTemplate() {
        return [
            'cart-sidebar',
        ];
    }

    getSelectorCheckboxCGV() {
        return '#accept_cgv';
    }

    getNoValideCodeElement() {
        return $('#no_valide_code');
    }

    getElementLoaderModal() {
        return $('.loading');
    }

    getSelectorCartValidation() {
        return '.cart-validate';
    }

    getSelectorUpQuantity() {
        return '.qte .button_plus';
    }

    getSelectorDownQuantity() {
        return '.qte .button_moins';
    }

    getSelectorDifferentAddress() {
        return '#useDifferentAddress';
    }

    getConstructionSelector() {
        return '#select-construction';
    }

    getGuestInvoiceAddressContainer() {
        return '.guest-invoice-address-container';
    }

    getAddressFormSelector() {
        return '#address-form';
    }

    getCnCButtonSelector() {
        return '#select-CnC';
    }

    getRdvButtonSelector() {
        return '.take-appointment';
    }

    getCommandTypeChoiceSelector() {
        return '.command-type-choice';
    }

    getTypeCommandSelector() {
        return '.command-type-btn';
    }

    getShippingMeansChoiceSelector() {
        return '.shop-delivery';
    }

    getOrderValidationBtnSelector()
        :
        string {
        return '.order-validation-btn';
    }

    getQuotationValidationBtnSelector()
        :
        string {
        return '.quotation-validation-btn';
    }

    getModalBodySelector()
        :
        string {
        return '.modal-content';
    }

    getCnCModalSelector() {
        return 'driveStep-1';
    }

    getCnCPreviousBtnSelector() {
        return 'CnC-prev';
    }

    getValidatedButton() {
        return 'a.cart-validate';
    }

    reloadCart() {
        (window as any).HegydCore.sendRequest($('.page-shopping-cart').data('route_refresh'), 'GET', {
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            this.updateCartViews(data);
        });
    }

    updateProductQuantity($inputQuantity
                              :
                              JQuery
    ) {
        (window as any).HegydCore.sendRequest($inputQuantity.data('route'), 'PUT', {
            product_id: $inputQuantity.parents(this.getSelectorCartLine()).data('product_id'),
            user_id: $inputQuantity.parents(this.getSelectorCartLine()).data('user_id'),
            quantity: $inputQuantity.val(),
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            this.updateCartViews(data);
        });
    }

    updateConstruction($constructionElement
                           :
                           JQuery
    ) {
        (window as any).HegydCore.sendRequest($constructionElement.data('route'), 'PUT', {
            construction_id: $constructionElement.val(),
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            this.updateCartViews(data);
        });
    }

    deleteProduct($removeCross
                      :
                      JQuery
    ) {
        this.askToDelete($removeCross.data('message'), $removeCross.data('button'), () => {
            (window as any).HegydCore.sendRequest($removeCross.attr('href'), 'DELETE', {
                product_id: $removeCross.parents(this.getSelectorCartLine()).data('product_id'),
                user_id: $removeCross.parents(this.getSelectorCartLine()).data('user_id'),
                return_templates: this.getAllCartTemplate(),
            }, (data: any) => {
                this.updateCartViews(data);
                (window as any).dataLayer.push(data.gtm);
                (window as any).Swal.close();
            });
        });
    }

    updateCartViews(data
                        :
                        any
    ) {
        (window as any).updateCartViews(data);
        this.initEvents();
    }

    initCartAddressesModal(url
                               :
                               string, loadedCallback
                               :
                               () => any = null
    ) {
        (window as any).HegydCore.initRemoteModal('#cart-modal', url, loadedCallback, (data: any) => {
            setTimeout(() => {
                this.updateCartViews(data);
                (window as any).toastr.success($('#cart-modal').data('message-address-updated-success'));
            }, 300);
        });
    }

    askToDelete(deleteText
                    :
                    any, buttonText
                    :
                    any, callback
                    :
                    any
    ) {
        (window as any).Swal.fire({
            title: deleteText.title,
            html: deleteText.message,
            allowOutsideClick: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: buttonText.cancel,
            confirmButtonText: buttonText.confirm,
            showLoaderOnConfirm: true,
            preConfirm() {
                return new Promise((resolve) => {
                    if (callback) {
                        callback(resolve);
                    }
                });
            },
        }).then(() => {
            (window as any).Swal.close();
        });
    }

    deleteCart($linkResetCart
                   :
                   JQuery
    ) {
        this.askToDelete($linkResetCart.data('message'), $linkResetCart.data('btn_text'), () => {
            (window as any).HegydCore.sendRequest($linkResetCart.attr('href'), 'PUT', {}, () => {
                window.location.reload();
            });
        });
    }

    selectPaymentMean(paymentMean
                          :
                          HTMLLinkElement
    ) {
        if (paymentMean.getAttribute('data-payment-mean')) {
            (window as any).HegydCore.sendRequest(paymentMean.parentElement.getAttribute('data-route'), 'PUT', {
                'payment-means': paymentMean.getAttribute('data-payment-mean'),
                'update-cart': true,
            }, () => {
                /* Modal Monetico */
                if (paymentMean.getAttribute('data-payment') === 'monetico') {
                    (window as any).HegydCore.initRemoteModal('#cart-modal', paymentMean.getAttribute('href'), () => {
                    }, () => {
                    }, () => {
                    }, false);
                } else {
                    window.location.href = paymentMean.href;
                }
            });
        } else {
            window.location.href = paymentMean.href;
        }
    }

    // toggleFavoris(element: Element) {
    //     (window as any).HegydCore.sendRequest(element.getAttribute('href'), 'PUT', {}, ({ message }: { message: string}) => {
    //         (window as any).toastr.success(message);
    //         this.reloadCart();
    //     });
    // }

    toggleValidationCGV($element
                            :
                            JQuery
    ) {
        (window as any).HegydCore.sendRequest($element.data('route'), 'PUT', {
            'update-cart': true,
            accept_cgv: $element.prop('checked') ? 1 : 0,
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            this.toggleValidCart(data.isCartValid);
            this.updateCartViews(data);
        });
    }

    updateComment() {
        (window as any).HegydCore.sendRequest($('#comment').data('route'), 'PUT', {
            'update-cart': true,
            comment: $(this.getSelectorComment()).val(),
        });
    }

    updateConstructionName() {
        (window as any).HegydCore.sendRequest($('#construction-name').data('route'), 'PUT', {
            'update-cart': true,
            construction_reference: $(this.getSelectorConstructionName()).val(),
            return_templates: this.getSideBarCartTemplate(),
        }, (data: any) => {
            this.updateCartViews(data);
        });
    }

    updateDeliveryWishDate() {
        (window as any).HegydCore.sendRequest($(this.getSelectorDeliveryWishElement()).data('route'), 'PUT', {
            'update-cart': true,
            delivery_wish_at: $(this.getSelectorDeliveryWishElement()).val(),
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            this.updateCartViews(data);
            // On va mettre à jour les datas mounts après la maj des vues
            this.initAddressMount()
        });
    }

    initAddressMount() {
        const container = document.querySelector('#cart-addresses-container');
        if (container) {
            (window as any).Kernel.mountComponents(container);
        }
    }

    applyCodePromo() {
        const code: string = this.getElementAddCodePromo().val().toString();
        if (code.length === 0) {
            this.getNoValideCodeElement().show();
            return false;
        }
        (window as any).HegydCore.sendRequest(this.getElementAddCodePromo().data('route'), 'POST', {
            code,
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            (window as any).toastr.success(data.text);
            this.updateCartViews(data);
            // On va mettre à jour les datas mounts après la maj des vues
            this.initAddressMount()
        }, ({responseJSON}: { responseJSON: any }) => {
            this.getNoValideCodeElement().empty().html(responseJSON.text).show();
        });
        return true;
    }

    removeCodePromo() {
        (window as any).HegydCore.sendRequest(this.getElementRemoveCodePromo().attr('href'), 'DELETE', {
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            (window as any).toastr.success(data.text);
            this.updateCartViews(data);
            // On va mettre à jour les datas mounts après la maj des vues
            this.initAddressMount()
        });
    }

    removeDeliveryDate() {
        (window as any).HegydCore.sendRequest(this.getElementRemoveDeliveryDate().attr('href'), 'DELETE', {
            return_templates: this.getAllCartTemplate(),
        }, (data: any) => {
            (window as any).toastr.success(data.text);
            this.updateCartViews(data);
            // On va mettre à jour les datas mounts après la maj des vues
            this.initAddressMount()
        });
    }

    updateQuantity(element
                       :
                       Element, operation
                       :
                       string
    ) {
        const quantityElement = element.closest('.qte').querySelector(this.getSelectorInputQuantity()) as HTMLInputElement;
        let val = parseInt(`${quantityElement.value}`, 10);
        if (operation === '+') {
            val += 1;
        } else if (val > 1) {
            val -= 1;
        }
        quantityElement.value = `${val}`;
        quantityElement.dispatchEvent(new Event('change'));
    }

    showHideGuestInvoiceAddress() {
        const element = document.querySelector(this.getSelectorDifferentAddress()) as HTMLInputElement;
        const guestInvoiceAddressContainer = document.querySelector(this.getGuestInvoiceAddressContainer()) as HTMLElement;
        if (element.checked) {
            guestInvoiceAddressContainer.classList.remove('d-none');
        } else {
            guestInvoiceAddressContainer.classList.add('d-none');
        }
    }

    addAddressListener() {
        const addresses = document.querySelectorAll(this.getSelectorAddAddress());
        if (addresses) {
            addresses.forEach((addAddress) => {
                addAddress.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.initCartAddressesModal(addAddress.getAttribute('href') ?? '/');
                });
            });
        }
    }

    editAddressListener() {
        const addresses = document.querySelectorAll(this.getSelectorEditAddress());
        if (addresses) {
            addresses.forEach((editAddress) => {
                editAddress.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.initCartAddressesModal(editAddress.getAttribute('href') ?? '/');
                });
            });
        }
    }

    openCnCModal(url
                     :
                     string
    ) {
        // (selector, remoteUrl, afterLoadedCallback, successCallback, errorCallback, ajaxSubmitForm)
        (window as any).HegydCore.initRemoteModal((`#${this.getCnCModalSelector()}`), url, () => {
            // callback after loaded
            document.querySelectorAll(this.getRdvButtonSelector())
                .forEach((takeAppoint) => {
                    takeAppoint.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.updateModalContent(e.target);
                    });
                });
            (() => new StoreLocator(this.CnCModal.querySelector('[data-mount="StoreLocator"]')))();
        }, () => {
            setTimeout(() => {
                // this.updateCartViews(data);
                (window as any).toastr.success($(`#${this.getCnCModalSelector()}`).data('message-address-updated-success'));
            }, 300);
        });
    }

    /* Init all cart events */
    initEvents() {
        this.addValidateButtonsListener();
        this.initFlatPickr();
        this.addressModal = document.getElementById('cart-modal');
        // this.onModalShow();
        this.onModalHide();
        /* Changement de la quantité d'une ligne */
        const inputQty = document.querySelectorAll(this.getSelectorInputQuantity());
        if (inputQty) {
            inputQty.forEach((btn) => {
                btn.addEventListener('change', ({target}) => {
                    this.updateProductQuantity($(target) as JQuery<HTMLElement>);
                });
            });
        }

        /* Suppression d'une ligne du panier */
        const btnRmv = document.querySelectorAll(this.getSelectorRemoveCartLine());
        if (btnRmv) {
            btnRmv.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.deleteProduct($(e.target).closest(this.getSelectorRemoveCartLine()) as JQuery<HTMLElement>);
                });
            });
        }

        /* Choix d'une adresse */
        document.querySelectorAll(this.getSelectorChooseAddress()).forEach((chooseAddress) => {
            chooseAddress.addEventListener('click', (e) => {
                e.preventDefault();
                this.initCartAddressesModal(chooseAddress.getAttribute('href') ?? '/', () => {
                    this.addAddressListener();
                    this.editAddressListener();
                });
            });
        });

        /* Remise à zéro du panier */
        const btnResetCart = document.querySelector(this.getSelectorResetCart());
        if (btnResetCart) {
            btnResetCart.addEventListener('click', (e) => {
                e.preventDefault();
                this.deleteCart($(e.target).closest(this.getSelectorResetCart()) as JQuery<HTMLElement>);
            });
        }

        /* Validation des CGV */
        const inputValidCgv = document.querySelector(this.getSelectorCheckboxCGV());
        if (inputValidCgv) {
            inputValidCgv.addEventListener('change', (e) => {
                e.preventDefault();
                this.toggleValidationCGV($(e.target) as JQuery<HTMLElement>);
            });
        }

        /* Ajout d'un code promotion */
        const btnPromoCode = document.querySelector(this.getSelectorApplyCodePromo());
        if (btnPromoCode) {
            btnPromoCode.addEventListener('click', (e) => {
                e.preventDefault();
                this.applyCodePromo();
            });
        }

        /* Ajout d'un commentaire */
        const commentElement = document.querySelector(this.getSelectorComment());
        if (commentElement) {
            commentElement.addEventListener('change', () => {
                this.updateComment();
            });
        }
        /* Ajout un nom de chantier  */
        const constructionNameElement = document.querySelector(this.getSelectorConstructionName());
        if (constructionNameElement) {
            constructionNameElement.addEventListener('change', () => {
                this.updateConstructionName();
            });
        }
        const deliveryWishElement = document.querySelector(this.getSelectorDeliveryWishElement());
        if (deliveryWishElement) {
            deliveryWishElement.addEventListener('change', () => {
                this.updateDeliveryWishDate();
            });
        }
        /* Changement d'un chantier */
        const constructionElement = document.querySelector(this.getConstructionSelector());
        if (constructionElement) {
            constructionElement.addEventListener('change', ({target}) => {
                this.updateConstruction($(target) as JQuery<HTMLElement>);
            });
        }
        /* Suppression d'un code promotion */
        const removePromoCodeElement = document.querySelector(this.getSelectorRemoveCodePromo());
        if (removePromoCodeElement) {
            removePromoCodeElement.addEventListener('click', (e) => {
                e.preventDefault();
                this.removeCodePromo();
            });
        }

        /* Suppression d'un code promotion */
        const removeDeliveryDateElement = document.querySelector(this.getSelectorRemoveDeliveryDate());
        if (removeDeliveryDateElement) {
            removeDeliveryDateElement.addEventListener('click', (e) => {
                e.preventDefault();
                this.removeDeliveryDate();
            });
        }

        /* Quantité fleche up */
        document.querySelectorAll(this.getSelectorUpQuantity()).forEach((up) => {
            up.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateQuantity(up, '+');
            });
        });

        /* Quantité fleche down */
        document.querySelectorAll(this.getSelectorDownQuantity()).forEach((down) => {
            down.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateQuantity(down, '-');
            });
        });

        // selection d'un moyen de paiement
        document.querySelectorAll(this.getSelectorCartValidation()).forEach((paymentMean: HTMLLinkElement) => {
            paymentMean.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectPaymentMean(paymentMean);
            });
        });

        if (document.querySelector(this.getSelectorDifferentAddress())) {
            // On gère l'evt sur la checkbox
            this.showHideGuestInvoiceAddress();
            const changeAddressElement = document.querySelector(this.getSelectorDifferentAddress());
            if (changeAddressElement) {
                changeAddressElement.addEventListener('change', () => {
                    this.showHideGuestInvoiceAddress();
                });
            }
            // On rajoute un evt sur le btn étape suivante.
            const nextStepElement = document.querySelector(this.getSelectorNextStep());
            if (nextStepElement) {
                nextStepElement.addEventListener('click', (e) => {
                    e.preventDefault();
                    (document.querySelector('form.basket-step-two') as HTMLFormElement).submit();
                });
            }
        }

        // dans le cas de l'addresse on modifie le comportement du bouton etape suivante pour passer l'addresse selectionnée
        const addressForm = document.querySelector((this.getAddressFormSelector()));
        if (addressForm) {
            const button = document.querySelector('.btn-next-step');
            if (button) {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    // @ts-ignore
                    addressForm.submit();//
                });
            }
        }
        this.initCommandType();
        this.updateTooltips();
    }

    initCnCModal() {
        this.CnCModal = document.getElementById(this.getCnCModalSelector());
        /* Bouton choisir le click adn collect */
        const CnCbtn = document.querySelectorAll(this.getCnCButtonSelector());
        if (CnCbtn) {
            CnCbtn.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    event.preventDefault();
                    const url = btn.getAttribute('data-url');
                    if (url) {
                        this.openCnCModal(url);
                    }
                });
            });
        }
    }

    initFlatPickr() {
        var firstDay = 1;
        var date = new Date();
        var hour = date.getHours();

        if (hour >= 15) {
            firstDay = 2;
        }
        function parseDate(dateStr) {
            var parts = dateStr.split('-');
            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10) - 1; // Les mois commencent à 0
            var year = parseInt(parts[2], 10);
            return new Date(year, month, day);
        }
        // Récupération des dates depuis les attributs data-* de l'élément input

        const disabledDates = [
            new Date(new Date().getFullYear(), 0, 1), // 1er janvier
            new Date(new Date().getFullYear(), 11, 25), // 25 décembre
            new Date(new Date().getFullYear(), 10, 11), // 11 novembre
            new Date(new Date().getFullYear(), 10, 1), // 1er novembre
            new Date(new Date().getFullYear(), 4, 1), // 1er mai
            new Date(new Date().getFullYear(), 4, 8), // 8 mai
            new Date(new Date().getFullYear(), 6, 14), // 14 juillet
            new Date(new Date().getFullYear(), 7, 15), // 15 août
            new Date(2025, 4, 9), // 9 mai
            new Date(2025, 4, 11), // 11 mai
            new Date(2025, 4, 29), // 29 mai
            new Date(2025, 4, 30), // 30 mai
            function(date) {
                // Désactiver les week-ends (samedi et dimanche)
                if (date.getDay() === 0 || date.getDay() === 6) {
                    return true;
                }
                // Désactiver les dates envoyé par Partoot BO (Dates fermeture agence)
                const inputCalendar = document.getElementById('calendar-select-range');
                if (inputCalendar) {
                    const closedStartDate = inputCalendar.getAttribute('data-closed-start-at');
                    const closedEndDate = inputCalendar.getAttribute('data-closed-end-at');
                    if (closedStartDate && closedEndDate) {
                        const startDate = new Date(closedStartDate);
                        const endDate = new Date(closedEndDate);
                        return date >= startDate && date <= endDate;
                    }
                }
            }
        ];

        function calculateMaxDate(minDate, daysRequired) {
            var date = new Date(minDate);
            var availableDays = 0;

            while (availableDays < daysRequired) {
                date.setDate(date.getDate() + 1);
                if (!disabledDates.some(disable => typeof disable === 'function' ? disable(date) : disable.getTime() === date.getTime())) {
                    availableDays++;
                }
            }
            return date;
        }

        // Définir la date minimale et calculer la date maximale
        var daysRequired = 11;
        var minDate = new Date().fp_incr(firstDay);
        var maxDate = calculateMaxDate(minDate, daysRequired);

        // @ts-ignore
        flatpickr('#calendar-select-range', {
            enableTime: false,
            dateFormat: "d-m-Y",
            "minDate": minDate,
            "maxDate": maxDate,
            "locale": French,
            "disable": disabledDates,
            onReady: function(selectedDates, dateStr, instance) {
                // Recalculer maxDate à l'ouverture pour s'assurer qu'on affiche bien 15 jours disponibles
                var newMaxDate = calculateMaxDate(instance.config.minDate, daysRequired);
                instance.set('maxDate', newMaxDate);
            },
            onChange: function(selectedDates, dateStr, instance) {
                // Recalculer maxDate lors des changements de dates pour s'assurer qu'on affiche bien 15 jours disponibles
                var newMaxDate = calculateMaxDate(instance.config.minDate, daysRequired);
                instance.set('maxDate', newMaxDate);
            }
        });
    }

    /*------------------------------------------------------------------------------------------------------------------
    * Finalisation de panier
    *-----------------------------------------------------------------------------------------------------------------*/

    // Selection type de commande
    initCommandType() {
        const radioBtns = document.querySelectorAll(this.getCommandTypeChoiceSelector());
        if (radioBtns) {
            radioBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    // ici on fait en sorte de ne pas envoyer d'AJAX si on a déja selectionné le bouton
                    // (sinon meme si le radio est checked ca envoie quand meme l'AJAX)
                    const input: HTMLInputElement = this.getRadioInput(event, 'delivery-plan');
                    if (input.checked) {
                        return;
                    }
                    input.checked = true;
                    this.toggleCommandType($(btn));
                });
            });
        }
    }

    toggleCommandType($element
                          :
                          JQuery<Element>
    ) {
        (window as any).HegydCore.sendRequest($element.data('route'), 'PUT', {
            'update-cart': true,
            'command-type': $element.data('command-type'),
            return_templates: ['cart-payment-means', 'cart-shipping-means'],
        }, (data: any) => {
            this.updateCartViews(data);
            this.toggleValidCart(data.isCartValid);
            this.toggleValidationButtons($element.data('command-type'));
        });
    }

    initSelectShippingMeans() {
        const radioBtns = document.querySelectorAll(this.getShippingMeansChoiceSelector());
        if (radioBtns) {
            radioBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const input: HTMLInputElement = this.getRadioInput(event, 'shipping_means');
                    if (input.checked) {
                        return;
                    }
                    input.checked = true;

                    this.toggleShippingMeans($(btn));
                });
            });
        }
    }

    toggleShippingMeans($element
                            :
                            JQuery<Element>
    ) {
        (window as any).HegydCore.sendRequest($element.data('route'), 'PUT', {
            'update-cart': true,
            'shipping-means': $element.data('shipping-means'),
            'current-shop': this.currentShopId,
            return_templates: ['cart-header', 'cart-sidebar', 'cart-addresses', 'cart-date'],
        }, (data: any) => {
            this.updateCartViews(data);
            // on va mettre à jour les datas mounts après la maj des vues
            this.initAddressMount();
        });
    }

    getRadioInput(event
                      :
                      Event, inputName
                      :
                      string
    ):
        HTMLInputElement {
        let target = $(event.target)[0];
        if (target.nodeName !== 'LABEL') {
            target = $(target).closest('label.delivery-choice');
        }
        // @ts-ignore On a toujours cet element si on arrive ici.
        return $(target).find(`input[name=${inputName}]`).get(0);
    }

    onModalHide() {
        if (this.addressModal != null) {
            this.addressModal.addEventListener('hidden.bs.modal', () => {
                const modalContent = this.addressModal?.querySelector('#modalAccountContent');
                if (modalContent) {
                    modalContent.innerHTML = '';
                }
                this.addressModalInstance = null;
            });
        }
        if (this.CnCModal != null) {
            this.CnCModal.addEventListener('hidden.bs.modal', () => {
                const modalContent = this.CnCModal?.querySelector('#modalAccountContent');
                if (modalContent) {
                    modalContent.innerHTML = '';
                }
                this.CnCModalInstance = null;
            });
        }
    }

    onUpdateContentModal() {
        if (this.CnCModal !== null) {
            // @ts-ignore  this.CnCModal !== null alors querySelector('[data-mount="StoreLocator"] !== null

            // @ts-ignore idem
            (() => new SlotTime(this.CnCModal.querySelector('[data-mount="SlotTime"]')))();
        }
    }

    toggleValidCart(isValid
                        :
                        boolean
    ) {
        const btns = $(this.getSelectorCartValidation());
        btns.each(function () {
            if ($(this).hasClass('disabled') && isValid) {
                $(this).removeClass('disabled');
            } else if (!$(this).hasClass('disabled') && !isValid) {
                $(this).addClass('disabled');
            }
        });
    }

    /**
     *
     * @param type = 1 pour afficher les boutons de paiement (habituel ou carte de crédit)
     * type = 2 pour le bouton devis.
     */
    toggleValidationButtons(type
                                :
                                number
    ) {
        let hide = $(this.getQuotationValidationBtnSelector());
        let show = $(this.getOrderValidationBtnSelector());
        if (type === 2) {
            hide = $(this.getOrderValidationBtnSelector());
            show = $(this.getQuotationValidationBtnSelector());
        }
        hide.each(function () {
            $(this).hide();
        });

        show.each(function () {
            $(this).show();
        });
    }

    addValidateButtonsListener() {
        const validatedButtons = document.querySelectorAll(this.getValidatedButton());
        if (validatedButtons) {
            validatedButtons.forEach((validateButton) => {
                validateButton.addEventListener('click', (e) => {
                    e.stopPropagation(); // Arrête la propagation de l'événement
                    validateButton.classList.add('disabled'); // Ajout de la classe 'disabled' pour désactiver le lien
                    validateButton.removeAttribute('onclick'); // Suppression de l'attribut onclick pour éviter le double-clic
                });
            });
        }
    }

    updateModalContent(element
                           :
                           HTMLLinkElement, selector
                           :
                           string = '.modal-content'
    ):
        void {
        fetch(element.getAttribute('href') ?? '/',
            {
                method: 'GET',
                headers:
                    Helper.createFetchHeader(),
            }
        )
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                if (this.CnCModal) {
                    const modalContent = this.CnCModal.querySelector(selector);
                    if (modalContent) {
                        modalContent.innerHTML = data;
                    }
                    this.onUpdateContentModal();
                }
            });
    }

    updateTooltips() {
        // On réinstance le tooltip des btn commander dans le cas ou l'on refresh ma vue
        const formActions = (document.querySelector('.form-actions') as HTMLFormElement);
        if (formActions) {
            window.bootstrap.Tooltip.getOrCreateInstance(formActions);
        }
    }
}

// On document ready
document
    .addEventListener(
        'DOMContentLoaded'
        , () => {
            (() =>
                    new

                    Cart()

            )();
        }
    )
;
